import { useSecureFileUrl } from "@tellescope/tanstack-query";
import { useTranslation } from "react-i18next";

export interface SignaturePdfDocumentProps {
  pdfAttachment: string;
}

export const SignaturePdfDocument = ({ pdfAttachment }: SignaturePdfDocumentProps) => {
  const { t } = useTranslation("forms");
  const pdfUrl = useSecureFileUrl(pdfAttachment);

  if (!pdfUrl) return null;

  return <iframe title={t("Document to sign")} src={pdfUrl} className="w-full h-96 border rounded" />;
};
